import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { statusLabel } from "../lib/api";

const STYLES = {
  done: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  in_progress: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  not_started: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};
const ICONS = { done: CheckCircle2, in_progress: Loader2, not_started: XCircle };

export const StatusBadge = ({ status, testId }) => {
  const Icon = ICONS[status] || XCircle;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 font-mono text-[11px] uppercase tracking-wider ${STYLES[status] || STYLES.not_started}`}>
      <Icon className="h-3 w-3" />
      {statusLabel(status)}
    </span>
  );
};
